import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator/index';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEItemText, FHEDivider, FormEditButton, FHETextField, FHEReactSelect } from 'data/components';
import { Toastr } from 'data/common';
import memoizeOne from 'memoize-one';
import { updateProductModule } from '../../../../../data/Products/actions';

class Flowmeter extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        moduleType: PropTypes.string,
        productType: PropTypes.string,
        lineTypeDiversity: PropTypes.string,
        code: PropTypes.string,
        lineType: PropTypes.string,
        label: PropTypes.string,
        favorite: PropTypes.number,
        updateProductModule: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        expanded: PropTypes.string,
        productModulekey: PropTypes.string.isRequired,
        profile: PropTypes.object.isRequired,
        type: PropTypes.string
    };

    static defaultProps = {
        expanded: null,
        moduleType: null,
        productType: null,
        lineTypeDiversity: null,
        code: null,
        lineType: null,
        label: null,
        favorite: null,
        type: null
    };

    constructor(props) {
        super(props);
        this.state = {
            formDisabled: true,
            textInput_error: {},
            sendLoading: false,
            form: {
                moduleType: null,
                label: null,
                lineTypeDiversity: null,
                favorite: null
            },
            loading: false
        };
        this.types = [
            { value: 'socket', label: Translator.translate('general.productModules.new') },
            { value: 'lighting', label: Translator.translate('general.productModules.lighting') },
            { value: 'shutterstore', label: Translator.translate('general.productModules.shutterstore') },
            { value: 'thermostat', label: Translator.translate('general.productModules.thermostat') },
            { value: 'security', label: Translator.translate('general.productModules.security') },
            { value: 'photovoltaic', label: Translator.translate('general.productModules.photovoltaic') },
            { value: 'ventilation', label: Translator.translate('general.productModules.ventilation') }
        ];
        this.lines = [
            { value: 'gas', label: Translator.translate('general.productModules.gas') },
            { value: 'watt', label: Translator.translate('general.productModules.watt') },
            { value: 'water', label: Translator.translate('general.productModules.water') }
        ];
        this.favorites = [
            { value: 0, label: Translator.translate('general.productModules.0') },
            { value: 1, label: Translator.translate('general.productModules.1') }
        ];
    }

    static getDerivedStateFromProps(props, state) {
        const { formDisabled } = state;
        const { moduleType, label, lineTypeDiversity, favorite } = props;
        if (formDisabled) {
            let form = {
                moduleType: state.form.moduleType,
                label: state.form.label,
                lineTypeDiversity: state.form.lineTypeDiversity,
                favorite: state.form.favorite
            };
            if (props.moduleType !== state.form.moduleType) {
                form.moduleType = moduleType;
            }
            if (props.label !== state.form.label) {
                form.label = label;
            }
            if (props.lineTypeDiversity !== state.form.lineTypeDiversity) {
                form.lineTypeDiversity = lineTypeDiversity;
            }
            if (props.favorite !== state.form.favorite) {
                form.favorite = favorite;
            }
            return {
                form: form,
                loading: false
            };
        } else {
            return null;
        }
    }

    handleEdit = () => {
        const { formDisabled } = this.state;
        if (formDisabled === true) {
            this.setState({
                formDisabled: false
            });
        } else {
            this.loadInputs();
            this.setState({
                formDisabled: true,
                textInput_error: {}
            });
        }
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };

    handleChangeWithVerification = event => {
        const { form, textInput_error } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        const fieldLengthRules = {
            label: 255
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = form[event.target.name];
        if (targetValue === '') targetValue = null;

        this.setState({
            form: { ...form, [event.target.name]: targetValue },
            textInput_error: newTextInput_error
        });
    };

    handleChange = event => {
        const { form } = this.state;

        let value;
        if (event.target.name === 'favorite') {
            value = parseInt(event.target.value);
        } else {
            value = event.target.value;
        }

        this.setState({
            form: { ...form, [event.target.name]: value }
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    loadInputs = () => {
        const { moduleType, label, lineTypeDiversity, favorite } = this.props;
        this.setState({
            loading: false,
            form: {
                moduleType: moduleType,
                label: label,
                lineTypeDiversity: lineTypeDiversity,
                favorite: favorite
            }
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    formatForm = () => {
        const { form } = this.state;
        let newForm = form;
        Object.keys(newForm).forEach(key => {
            if (newForm[key] === '') {
                newForm[key] = null;
            }
        });
        this.setState({
            form: newForm
        });
    };

    confirmEdit = () => {
        const { form } = this.state;
        const { updateProductModule, match, code, type, lineType } = this.props;

        this.formatForm();

        if (this.validateForm(form)) {
            this.setState({
                sendLoading: true,
                formDisabled: true
            });

            return updateProductModule(match.params.homeId, match.params.productIdentifier, match.params.productType, code, form, type, lineType)
                .then(() => {
                    Toastr.success(Translator.translate('generic.products.actions.editProductModuleSuccess'));
                    this.loadInputs();
                    this.setState({
                        formDisabled: true,
                        sendLoading: false
                    });
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false
                    });
                    Toastr.error(Translator.translate('generic.products.actions.editProductModuleError'));
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(error.validation.errors, Translator.translate('generic.products.actions.editProductModuleError'));
                    }
                });
        }
    };

    validateForm = () => {
        const errors = {};

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    };

    getSelectedFavorite = memoizeOne(favorite => {
        return this.favorites.find(x => x.value === favorite);
    });
    getSelectedLine = memoizeOne(line => {
        return this.lines.find(x => x.value === line);
    });
    getSelectedType = memoizeOne(type => {
        return this.types.find(x => x.value === type);
    });

    handleReactSelect = (event, options) => {
        const { form } = this.state;

        this.setState({
            form: { ...form, [options.name]: event.value }
        });
    };
    renderDataLoading = () => {
        const { formDisabled, textInput_error, form } = this.state;
        return (
            <Grid container spacing={3}>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHETextField
                        disabled={formDisabled}
                        id="label"
                        value={!form.label || form.label === null ? '' : form.label}
                        error={textInput_error.label}
                        label={Translator.translate('general.table.column.label')}
                        name="label"
                        onChange={this.handleChangeWithVerification}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEReactSelect
                        name="moduleType"
                        label={Translator.translate('general.table.column.moduleType')}
                        disabled={formDisabled}
                        onChange={this.handleReactSelect}
                        value={this.getSelectedType(form.moduleType)}
                        choices={this.types}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEReactSelect
                        name="lineTypeDiversity"
                        label={Translator.translate('general.table.column.lineTypeDiversity')}
                        disabled={formDisabled}
                        onChange={this.handleReactSelect}
                        value={this.getSelectedLine(form.lineTypeDiversity)}
                        choices={this.lines}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEReactSelect
                        name="favorite"
                        label={Translator.translate('general.table.column.favorite')}
                        disabled={formDisabled}
                        onChange={this.handleReactSelect}
                        value={this.getSelectedFavorite(form.favorite)}
                        choices={this.favorites}
                    />
                </Grid>
            </Grid>
        );
    };

    render() {
        const { productType, code, lineType, theme, expanded, productModulekey, profile, type } = this.props;
        const { formDisabled, sendLoading, loading } = this.state;
        const userRightUpdate =
            profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes(`productModules_${type}_${lineType}_update`);
        return (
            <div style={{ width: '100%' }}>
                {expanded === productModulekey && userRightUpdate && (
                    <FormEditButton
                        useSecondaryPosition
                        formDisabled={formDisabled}
                        handleEdit={this.handleEdit}
                        confirmEdit={this.confirmEdit}
                        sendLoading={sendLoading}
                    />
                )}

                <FHEContainerForm withoutPadding loading={loading} onRender={this.renderDataLoading} />
                <FHEContainerForm withoutPadding>
                    <Grid container spacing={3}>
                        <FHEDivider color={theme.palette.colors.grey100} />
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.productType')}
                                itemContent={Translator.translate(`general.productModules.${productType}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.lineType')}
                                itemContent={Translator.translate(`general.productModules.${lineType}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.code')} itemContent={code} />
                        </Grid>
                    </Grid>
                </FHEContainerForm>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    const productKey = props.productKey;
    const productModulekey = props.productModulekey;
    const product = state.environments.fhe.data.Products.getIn(['list', productKey], new Map());

    const productModule = state.environments.fhe.data.Products.getIn(['list', productKey, 'productModules', productModulekey], new Map());
    return {
        profile: state.data.user,
        type: product.get('type'),
        imageName: productModule.get('imageName'),
        moduleType: productModule.get('moduleType'),
        productType: productModule.get('productType'),
        lineTypeDiversity: productModule.get('lineTypeDiversity'),
        code: productModule.get('code'),
        lineType: productModule.get('lineType'),
        label: productModule.get('label'),
        productIdentifier: productModule.get('productIdentifier'),
        favorite: productModule.get('favorite'),
        productModulekey: productModulekey
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});
export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ updateProductModule }, dispatch)
    )(withStyles(styles, { withTheme: true })(Flowmeter))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/ProductModule/Fhe/Flowmeter.js